import React from "react";

const BUTTON_VARIANTS = {
  primary:
    "bg-theme-accent text-[#07090C] border border-theme-accent font-mono hover:opacity-90 focus-visible:ring-theme-accent",
  secondary:
    "bg-theme-panel text-theme-text border border-theme-border font-mono hover:border-theme-border-bright focus-visible:ring-theme-accent",
  ghost:
    "bg-transparent text-theme-text border border-theme-border font-mono hover:border-theme-border-bright hover:text-theme-on-background focus-visible:ring-theme-accent",
};

const BUTTON_SIZES = {
  sm: "px-3 py-2 text-xs",
  md: "px-4 py-2.5 text-sm",
  lg: "px-5 py-3 text-sm",
};

const Button = ({
  children,
  variant = "primary",
  size = "md",
  className = "",
  loading = false,
  ...props
}) => (
  <button
    className={`inline-flex items-center justify-center gap-2 rounded tracking-wide uppercase text-xs transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-theme-main disabled:opacity-70 disabled:pointer-events-none ${BUTTON_VARIANTS[variant] || BUTTON_VARIANTS.primary} ${BUTTON_SIZES[size] || BUTTON_SIZES.md} ${className}`}
    disabled={loading || props.disabled}
    {...props}
  >
    {loading ? "Loading..." : children}
  </button>
);

export default Button;
